import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import { IoMdCheckmarkCircle } from "react-icons/io";

export default function HomeBanner3() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  const highlights = [
    { title: "100% Tailor-made safaris" },
    { title: "Top-notch local safari guides" },
    { title: "Unlimited kilometers on game drives" },
    { title: "Expert Knowledge", text: "Hands-On Experience" },
    { title: "Best service", text: "Value for your money" },
    { title: "Excellent business relations in the tourism industry" },
    { title: "Reliable and reputable company" },
    { title: "Fleet of quality safari vehicles" },
  ];

  const bookingConditions = [
    {
      title: "Deposit and Payment",
      sections: [
        {
          heading: "Securing your place",
          text: "To secure your place, a 40% down payment is required in advance as per company policy; clients are also allowed to make the full payment once.",
        },
        {
          heading: "Payment channels",
          text: "Deposit and final payments can be made via bank transfer or online payment with Mastercard or Visa within 30 days prior to the tour, or in cash (USD) upon arrival. US dollar notes printed prior to 2001 are not accepted anywhere in Tanzania. Transfer details will be emailed on request.",
        },
        {
          heading: "Bank charges",
          text: "All bank charges, including transaction fees charged by our banking partners, are the responsibility of the client.",
        },
      ],
    },
    {
      title: "The Booking",
      sections: [
        {
          heading: "Agreement locale",
          text: "Bookings and ensuing contracts shall be deemed to have been concluded in Arusha, Tanzania and shall be interpreted according to the laws of the United Republic of Tanzania.",
        },
        {
          heading: "Company discretion",
          text: "The Company reserves the right to decline any booking without outlining the reasons for it.",
        },
        {
          heading: "Pre-trip care",
          text: "All travelers receive pre-trip information, a complete itinerary, and on-demand pre-travel advice via email or directly with our offices for any last-minute or personal queries.",
        },
        {
          heading: "Accommodation substitutions",
          text: "In the event a particular accommodation becomes unavailable upon booking, accommodation of a similar or higher standard will be substituted.",
        },
      ],
    },
  ];

  if (!ready) {
    return (
      <div className="container py-5 text-center">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <section className="MainBodySection py-5" style={{ background: "linear-gradient(180deg, #f7fbfa 0%, #eef5f3 100%)" }}>
      <div className="container">
        <div className="text-center mb-4" data-aos="fade-up">
          <div className="section-heading-pro section-heading-pro--center">
            <span className="section-heading-pro__rail" />
            <h2 className="section-heading-pro__title font-bold" style={{ color: "#162537" }}>
              Why Travelers Choose Kwetu
            </h2>
            <p className="section-heading-pro__meta mb-0">Our Difference</p>
          </div>
        </div>

        <div className="row g-3">
          {highlights.map((item, index) => (
            <div key={item.title} className="col-sm-6 col-lg-3">
              <article
                className="kwetu-highlight-card"
                data-aos={index % 2 === 0 ? "fade-up" : "fade-down"}
                data-aos-delay={index * 80}
              >
                <div className="kwetu-highlight-card__icon">
                  <IoMdCheckmarkCircle size={18} />
                </div>
                <div>
                  <h3 className="kwetu-highlight-card__title">{item.title}</h3>
                  {item.text && <p className="kwetu-highlight-card__text">{item.text}</p>}
                </div>
              </article>
            </div>
          ))}
        </div>

        <div className="kwetu-booking-conditions mt-5" data-aos="fade-up">
          <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap">
            <div>
              <h3 className="font-bold" style={{ color: "#142436" }}>
                Booking Conditions
              </h3>
            </div>
          </div>

          <div className="row g-4">
            {bookingConditions.map((section) => (
              <div key={section.title} className="col-md-6">
                <article className="kwetu-booking-card h-100">
                  <h4 className="font-bold text-primary">{section.title}</h4>
                  {section.sections.map((item) => (
                    <div key={item.heading} className="kwetu-booking-card__section">
                      <div className="kwetu-booking-card__section-heading">{item.heading}</div>
                      <p>{item.text}</p>
                    </div>
                  ))}
                </article>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
